import { useQuery } from "@tanstack/react-query";
import { fetchMonitorSummary, fetchMonitorEvents, fetchAiCostSummary } from "./api";

export const monitorKeys = {
  summary: (filter) => ["litellmMonitor", "summary", filter],
  events: (filter, limit) => ["litellmMonitor", "events", filter, limit],
};

export const aiCostKeys = {
  summary: (period) => ["aiCost", "summary", period],
};

// useMonitorSummary — manual refresh only (no refetchInterval). The backend always
// returns a well-formed (possibly empty) body, so callers can read fields directly.
export function useMonitorSummary(filter = {}, options = {}) {
  return useQuery({
    queryKey: monitorKeys.summary(filter),
    queryFn: () => fetchMonitorSummary(filter),
    ...options,
  });
}

export function useMonitorEvents(filter = {}, limit = 50) {
  return useQuery({
    queryKey: monitorKeys.events(filter, limit),
    queryFn: () => fetchMonitorEvents(filter, limit),
  });
}

// useAiCostSummary — manual refresh only, matching useMonitorSummary's pattern (the AI-monitor
// proof tile refetches alongside the rest of the page via the page's own refresh control).
export function useAiCostSummary(period, options = {}) {
  return useQuery({
    queryKey: aiCostKeys.summary(period),
    queryFn: () => fetchAiCostSummary(period),
    ...options,
  });
}
